<div class="container">
	<div class="title">{{ "RESET_PASSWORD" | translate }}</div>

	<form name="forgotPasswordForm">
		<p class="description">{{ "FORGOT_PASSWORD_HELP" | translate }}</p>

		<mat-form-field appearance="fill" class="full-width">
			<span matPrefix><i class="far fa-user"></i></span>
			<mat-label>{{'EMAIL' | translate}}</mat-label>
			<input type="email" [(ngModel)]="emailAddress" (keyup.enter)="requestNewPassword()" matInput
				name="emailAddress" auto-fillable-field autocapitalize="off">
		</mat-form-field>

		<p *ngIf="passwordErrorOccured" class="error-message">{{forgotPasswordErrorMessage}}.</p>

		<div class="button-container">
			<bb-button theme="rb" backgroundColor="white" (click)="cancel()">{{ 'CANCEL' | translate }}</bb-button>
			<bb-button theme="rb" backgroundColor="blue" (click)="requestNewPassword()" [disabled]="busy">
				{{ (forgotPasswordSent ? 'SEND_AGAIN' : 'SEND') | translate }}
			</bb-button>
		</div>
	</form>

	<bb-line-text>
		<a href="https://support.bluebillywig.com/online-video-platform-6-preview/authentication-and-login"
			target="_BLANK">{{ 'NEED_HELP' | translate }}</a>
	</bb-line-text>
</div>

<ng-template #emailSentModal>
	<p>{{ 'FORGOT_PASSWORD_SUCCESS' | translate : {email: emailAddress} }}</p>
</ng-template>
